import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import classnames from "classnames";
import { Box } from "../../Box/index.js";
import { CircularProgress } from "../../CircularProgress/index.js";
import { Label } from "../common/index.js";
import { Typography } from "../../Typography/index.js";
import { useStyles } from "../ChipsInput/ChipsInput.styles.js";
import { useRatingStyles } from "./RatingInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RatingInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RatingInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const RatingInput = (t0)=>{
    const $ = c(97);
    let chipMaxWidth;
    let error;
    let helperText;
    let items;
    let label;
    let onChange;
    let onClick;
    let rest;
    let t1;
    let t10;
    let t11;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== t0) {
        ({ label, items, value, onChange, onClick, required: t1, error, helperText, disabled: t2, loading: t3, tooltip: t4, size: t5, iconSize: t6, direction: t7, activeSingleOption: t8, testId, highlightRange: t9, fillMode: t10, showLabelBelow: t11, chipMaxWidth } = t0), rest = _object_without_properties(t0, [
            "label",
            "items",
            "value",
            "onChange",
            "onClick",
            "required",
            "error",
            "helperText",
            "disabled",
            "loading",
            "tooltip",
            "size",
            "iconSize",
            "direction",
            "activeSingleOption",
            "testId",
            "highlightRange",
            "fillMode",
            "showLabelBelow",
            "chipMaxWidth"
        ]);
        $[0] = t0;
        $[1] = chipMaxWidth;
        $[2] = error;
        $[3] = helperText;
        $[4] = items;
        $[5] = label;
        $[6] = onChange;
        $[7] = onClick;
        $[8] = rest;
        $[9] = t1;
        $[10] = t10;
        $[11] = t11;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
        $[19] = t9;
        $[20] = testId;
        $[21] = value;
    } else {
        chipMaxWidth = $[1];
        error = $[2];
        helperText = $[3];
        items = $[4];
        label = $[5];
        onChange = $[6];
        onClick = $[7];
        rest = $[8];
        t1 = $[9];
        t10 = $[10];
        t11 = $[11];
        t2 = $[12];
        t3 = $[13];
        t4 = $[14];
        t5 = $[15];
        t6 = $[16];
        t7 = $[17];
        t8 = $[18];
        t9 = $[19];
        testId = $[20];
        value = $[21];
    }
    const required = void 0 === t1 ? false : t1;
    const disabled = void 0 === t2 ? false : t2;
    const loading = void 0 === t3 ? false : t3;
    const tooltip = void 0 === t4 ? null : t4;
    const size = void 0 === t5 ? "large" : t5;
    const iconSize = void 0 === t6 ? "small" : t6;
    const direction = void 0 === t7 ? "row" : t7;
    const activeSingleOption = void 0 === t8 ? true : t8;
    const highlightRange = void 0 === t9 ? false : t9;
    const fillMode = void 0 === t10 ? true : t10;
    const showLabelBelow = void 0 === t11 ? false : t11;
    const { classes: chipsClasses } = useStyles();
    const { classes: ratingClasses } = useRatingStyles();
    const [hoveredValue, setHoveredValue] = useState(null);
    let t12;
    if ($[22] !== onChange) {
        t12 = (t13)=>{
            const { target: t14 } = t13;
            const { value: inputValue } = t14;
            null == onChange || onChange(inputValue);
        };
        $[22] = onChange;
        $[23] = t12;
    } else t12 = $[23];
    const handleChange = t12;
    let t13;
    if ($[24] !== onChange || $[25] !== onClick) {
        t13 = (isActive)=>(event)=>{
                if (isActive) {
                    event.stopPropagation();
                    event.preventDefault();
                    null == onChange || onChange(void 0);
                }
                null == onClick || onClick();
            };
        $[24] = onChange;
        $[25] = onClick;
        $[26] = t13;
    } else t13 = $[26];
    const handleChipClick = t13;
    let t14;
    if ($[27] !== highlightRange) {
        t14 = (itemValue)=>()=>{
                if (highlightRange) setHoveredValue(itemValue);
            };
        $[27] = highlightRange;
        $[28] = t14;
    } else t14 = $[28];
    const handleMouseEnter = t14;
    let t15;
    if ($[29] !== highlightRange) {
        t15 = ()=>{
            if (highlightRange) setHoveredValue(null);
        };
        $[29] = highlightRange;
        $[30] = t15;
    } else t15 = $[30];
    const handleMouseLeave = t15;
    let t16;
    if ($[31] !== highlightRange || $[32] !== hoveredValue || $[33] !== value) {
        t16 = (itemValue_0)=>{
            if (!highlightRange || "number" != typeof itemValue_0) return {
                hover: false,
                selected: false
            };
            const hasValue = null != value && "" !== value;
            const numValue = "number" == typeof value ? value : 0;
            const numHover = "number" == typeof hoveredValue ? hoveredValue : 0;
            const isHovering = null !== hoveredValue;
            return {
                hover: isHovering && itemValue_0 <= numHover,
                selected: hasValue && itemValue_0 <= numValue
            };
        };
        $[31] = highlightRange;
        $[32] = hoveredValue;
        $[33] = value;
        $[34] = t16;
    } else t16 = $[34];
    const getHighlightState = t16;
    let t17;
    if ($[35] !== ratingClasses.root) {
        t17 = classnames(ratingClasses.root, "aqa_rating_input");
        $[35] = ratingClasses.root;
        $[36] = t17;
    } else t17 = $[36];
    let t18;
    if ($[37] !== label || $[38] !== required || $[39] !== tooltip) {
        t18 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            className: "aqa_rating_input_label",
            required: required,
            tooltip: tooltip
        });
        $[37] = label;
        $[38] = required;
        $[39] = tooltip;
        $[40] = t18;
    } else t18 = $[40];
    const t19 = "row" === direction;
    const t20 = fillMode && ratingClasses.flexRow;
    let t21;
    if ($[41] !== chipsClasses.row || $[42] !== t20) {
        t21 = classnames(chipsClasses.row, t20, "aqa_rating_button");
        $[41] = chipsClasses.row;
        $[42] = t20;
        $[43] = t21;
    } else t21 = $[43];
    let t22;
    if ($[44] !== activeSingleOption || $[45] !== chipMaxWidth || $[46] !== chipsClasses || $[47] !== disabled || $[48] !== error || $[49] !== fillMode || $[50] !== getHighlightState || $[51] !== handleChipClick || $[52] !== handleMouseEnter || $[53] !== handleMouseLeave || $[54] !== iconSize || $[55] !== items || $[56] !== loading || $[57] !== ratingClasses || $[58] !== rest || $[59] !== showLabelBelow || $[60] !== size || $[61] !== value) {
        let t23;
        if ($[63] !== activeSingleOption || $[64] !== chipMaxWidth || $[65] !== chipsClasses || $[66] !== disabled || $[67] !== error || $[68] !== fillMode || $[69] !== getHighlightState || $[70] !== handleChipClick || $[71] !== handleMouseEnter || $[72] !== handleMouseLeave || $[73] !== iconSize || $[74] !== items.length || $[75] !== loading || $[76] !== ratingClasses || $[77] !== rest || $[78] !== showLabelBelow || $[79] !== size || $[80] !== value) {
            t23 = (t24)=>{
                const { label: itemLabel, value: itemValue_1, counter, color, icon } = t24;
                const active = itemValue_1 === value || activeSingleOption && 1 === items.length;
                const { hover: isHover, selected: isSelected } = getHighlightState(itemValue_1);
                let chipLabel;
                if (loading) chipLabel = /*#__PURE__*/ jsx(CircularProgress, {
                    size: 20,
                    color: itemValue_1 === value ? "primary" : "inherit"
                });
                if (!loading && !showLabelBelow) chipLabel = /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8",
                    ml: icon && itemLabel ? "2" : "0",
                    children: [
                        itemLabel,
                        !!counter && /*#__PURE__*/ jsx(Box, {
                            className: chipsClasses.counter,
                            children: counter
                        })
                    ]
                });
                return /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: showLabelBelow && itemLabel ? "12" : "0",
                    maxWidth: chipMaxWidth,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ jsx(FormControlLabel, {
                            value: itemValue_1,
                            className: classnames(chipsClasses.label, fillMode && ratingClasses.flexLabel),
                            disabled: disabled,
                            control: /*#__PURE__*/ jsx(Radio, {
                                className: chipsClasses.radio
                            }),
                            label: /*#__PURE__*/ jsx(Chip, _object_spread_props(_object_spread({}, rest), {
                                onClick: handleChipClick(active),
                                onMouseEnter: handleMouseEnter(itemValue_1),
                                onMouseLeave: handleMouseLeave,
                                label: chipLabel,
                                variant: "outlined",
                                disabled: disabled,
                                clickable: !disabled,
                                icon: !loading && icon ? /*#__PURE__*/ jsx(Box, {
                                    children: icon
                                }) : void 0,
                                className: classnames(chipsClasses.chip, chipsClasses[size], ratingClasses.defaultRating, active && chipsClasses.active, isHover && ratingClasses.hover, isSelected && ratingClasses.selected, error && chipsClasses.error, disabled && chipsClasses.disabled, active && disabled && chipsClasses.activeDisabled, color && chipsClasses[color], ratingClasses[`iconSize-${iconSize}`])
                            }))
                        }, itemValue_1),
                        showLabelBelow && itemLabel && /*#__PURE__*/ jsx(Typography, {
                            variant: "caption",
                            color: "text.light.secondary",
                            children: itemLabel
                        })
                    ]
                }, itemValue_1);
            };
            $[63] = activeSingleOption;
            $[64] = chipMaxWidth;
            $[65] = chipsClasses;
            $[66] = disabled;
            $[67] = error;
            $[68] = fillMode;
            $[69] = getHighlightState;
            $[70] = handleChipClick;
            $[71] = handleMouseEnter;
            $[72] = handleMouseLeave;
            $[73] = iconSize;
            $[74] = items.length;
            $[75] = loading;
            $[76] = ratingClasses;
            $[77] = rest;
            $[78] = showLabelBelow;
            $[79] = size;
            $[80] = value;
            $[81] = t23;
        } else t23 = $[81];
        t22 = items.map(t23);
        $[44] = activeSingleOption;
        $[45] = chipMaxWidth;
        $[46] = chipsClasses;
        $[47] = disabled;
        $[48] = error;
        $[49] = fillMode;
        $[50] = getHighlightState;
        $[51] = handleChipClick;
        $[52] = handleMouseEnter;
        $[53] = handleMouseLeave;
        $[54] = iconSize;
        $[55] = items;
        $[56] = loading;
        $[57] = ratingClasses;
        $[58] = rest;
        $[59] = showLabelBelow;
        $[60] = size;
        $[61] = value;
        $[62] = t22;
    } else t22 = $[62];
    let t23;
    if ($[82] !== handleChange || $[83] !== t19 || $[84] !== t21 || $[85] !== t22 || $[86] !== testId || $[87] !== value) {
        t23 = /*#__PURE__*/ jsx(RadioGroup, {
            row: t19,
            "data-testid": testId,
            value: value,
            onChange: handleChange,
            className: t21,
            children: t22
        });
        $[82] = handleChange;
        $[83] = t19;
        $[84] = t21;
        $[85] = t22;
        $[86] = testId;
        $[87] = value;
        $[88] = t23;
    } else t23 = $[88];
    let t24;
    if ($[89] !== error || $[90] !== helperText) {
        t24 = error && /*#__PURE__*/ jsx(Box, {
            mt: "4",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "accent.text.error",
                children: helperText
            })
        });
        $[89] = error;
        $[90] = helperText;
        $[91] = t24;
    } else t24 = $[91];
    let t25;
    if ($[92] !== t17 || $[93] !== t18 || $[94] !== t23 || $[95] !== t24) {
        t25 = /*#__PURE__*/ jsxs(FormControl, {
            className: t17,
            component: "fieldset",
            children: [
                t18,
                t23,
                t24
            ]
        });
        $[92] = t17;
        $[93] = t18;
        $[94] = t23;
        $[95] = t24;
        $[96] = t25;
    } else t25 = $[96];
    return t25;
};
export { RatingInput };
